import { PII_MASK_CLASS } from "@/lib/analytics";

/**
 * "Saved by <name>" on a saved list. The name is a customer's, so the whole
 * phrase sits behind the replay mask (ADR-0006) rather than the name alone.
 */
export function SavedByLabel({ label }: { label: string }) {
  return <span className={PII_MASK_CLASS}>Saved by {label}</span>;
}
